import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { AlertMessage } from '@/store/modules/alertsMessages/alertsMessagesTypes'
import AlertsMessagesListItemComponent from '@/components/AlertsMessages/AlertsMessagesListItemComponent.vue'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsMessagesListComponent',
  props: {
  alerts: {
    type: Array as PropType<AlertMessage[]>,
    required: true
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, AlertsMessagesListItemComponent }
}

})